import { useState, useEffect, useCallback } from "react";
import { useIntl } from "react-intl";
import { useTheme } from "@mui/styles";
import { useForm, Controller } from "react-hook-form";

const useNotificationCenter = () => {
  const { formatMessage } = useIntl();
  const formDataInit = {
    isSchedule: false,
    sendTime: "",
    targetAudiences: [
      {
        label: formatMessage({ id: "global.filter.all" }),
        isAllOption: true,
        value: "",
      },
    ],
    channels: {
      widget: false,
      discord: false,
      telegram: false,
      email: false,
      xmtp: false,
    },
    estimatedReachWhenSent: [
      {
        name: "email",
        number: null,
      },
      {
        name: "telegram",
        number: null,
      },
      {
        name: "discord",
        number: null,
      },
      {
        name: "xmtp",
        number: null,
      },
    ],
    title: "",
    content: "",
    image: "",
    ctaButtonEnabled: false,
    buttonText: "",
    buttonUrl: "",
    appendUTM: true,
    emailSetting: {
      companyAddress: "",
      privacyPolicyLink: "",
      emailAddress: "",
      websiteURL: "",
      socialMediaLink: "",
    },
  };
  const theme = useTheme();

  const [formData, setFormData] = useState(formDataInit);

  const [imagesError, setImagesError] = useState(null);
  const [targetAudiencesLoading, setTargetAudiencesLoading] = useState(false);

  const [uploadImgLoading, setUploadImgLoading] = useState(false);

  const {
    handleSubmit,
    control,
    setError,
    formState: { errors: errorsInfo, isValid, isDirty },
    clearErrors,
    reset,
    getValues,
    trigger,
    setValue,
  } = useForm({
    mode: "onSubmit",
    defaultValues: formDataInit,
  });

  return {
    formData,
    setFormData,
    handleSubmit,
    control,
    setError,
    errorsInfo,
    isValid,
    isDirty,
    clearErrors,
    reset,
    getValues,
    trigger,
    setValue,
    uploadImgLoading,
    setUploadImgLoading,
    imagesError,
    setImagesError,
    targetAudiencesLoading,
    setTargetAudiencesLoading,
  };
};

export default useNotificationCenter;
